<template>
  <div>
    <modal
      name="team-member-invite"
      :adaptive="true"
      :minHeight="500"
      :maxHeight="auto"
      :scrollable="true"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Add New Member - {{ team.name }}</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="addNewMember">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-4 xl:mb-0 px-2">
              <multiselect 
              v-model="selectedMembers"
              ref="multiselect"
              :custom-label="member"
              track-by="first_name" 
              placeholder="Select at least one member" 
              :multiple="true" 
              :options="users" 
              :close-on-select="true" 
              :clear-on-select="false" 
              :preserve-search="true" 
              :allow-empty="false" 
              :loading="true"
              :hide-selected="true"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span class="multiselect__single" v-if="selectedMembers.length &amp;&amp; !isOpen">{{ selectedMembers.length }} options selected</span>
                </template>
              </multiselect>
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 absolute inset-x-0 bottom-0 right-0 h-16">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Add"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamMemberInvite
  Description: This class representing a team member invite modal.
*/

/* Imports */
import TeamService from "@/services/team.service";
import Multiselect from 'vue-multiselect';
/* /Imports/ */

export default {
  /* 
    Define data with custom members state values. 
  */
  data() {
    return {
      users: [],
      selectedMembers: [],
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    Multiselect
  },

  /* 
    Define props from which we got team data. 
  */
  props: {
    team: null
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
     /* 
      Call UserModule class to obtain all users data.
    */
    getUsers() {
      this.$store.dispatch("userTable/getAllUsers").then(() => {
        this.users = this.$store.state.userTable.usersData;
      });
    },

    /* 
      Format user in multiselect dropdown.
    */
    member({ id, first_name, middle_name, last_name}) {
      return `${id}. ${first_name} ${middle_name} ${last_name}`;
    },

    /* 
      Call TeaemService class to invite member to the certain team.
    */
    addNewMember() {
      var data = { users: this.selectedMembers.map((member) => member.id)};
        
      TeamService.inviteMember(this.team.id, data).then(() => {
        location.reload();
      });
    },
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Check if user is authenticated and load all users after the instance.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }

    this.getUsers();
  }
};
</script>
